export const menuIds = {
  selectionSysId: '1796432349644296193',
  infoCenterId: '1796434260011356162',
}

export const certTypeList = [
  {label: '身份证', value: '1' },
  {label: '护照', value: '2' },
  {label: '军官证', value: '3' },
  {label: '港澳通行证', value: '4' },
  {label: '台胞证', value: '5' },
  {label: '其他', value: 'Z' },
]

export const registerTypeList = [
  { label: '法人', value: '1' },
  { label: '授权人', value: '2' }
]
